/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ClockXIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAACEElEQVR4nMWVSWsUQRTH+yAuF3FBRZQY7549iNjXxp63tFB5rzPKXJQIHoLeRf0e4jcQ9ANEES9eXEhyyMUliofk5sochMib6nJm0pPuCgxYUHTTXfX/vbUqSf7nIOodQtabwPIUSd4D6R9k7Q/e7RvrDVuza+Esy/YB6QNg/Y6sW81TviHrPefc3ijxTsfNAMtyu7COT9J3trdR/PKV+TNA8mUnESK50OHyYgNonUhmJ4o75w6YFU1WJtVoWgMsb9Jeb38NACT328KQRAAGEJK7E6pFfk4PoD+yrHvwHwALvRWTyCQS4PNVLgzD42t6qgAkfTz0gOTTtAHA+nEIsO7cBQBYvkas/zVSQfo7BsBcnrf1eTF3Dkg2WippY9SD9ci4bpq47cmcO5bn84edc0cQ9XYVhT6yLOa5O5Wm6Z6RHOiTKAB7y5ivHd3eRx0uU5u1BvN9UC7EApB1y6yuiuMlsLwyb4KWvQPrc2R9ONZo1hyxAK48QNLXvmJk2YRtIulKVUXPxrywIzfeC7lje4ri6nFkWQ2QIG5P+1c77IDlbSSkH+I9gARhb/laUXRPTswFgDsLrJ9jAIhzl0LMowE+HzLb7oksDhMaLicLlQ+XPWsh2n5l+pyIXYc1QFF0T1dVtBQEAfSEiQYgsL7YERCGNRJReb3qkw8DIOlmaCJgfWRCo9b6kMmS/WsFTGP8Bd+gwtA671V8AAAAAElFTkSuQmCC)
 */
export const ClockXIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M12.53 22.99c.32-.02.52-.34.49-.65a3 3 0 0 1 .86-2.46l.52-.53a.5.5 0 0 0 0-.7l-.52-.53a3 3 0 0 1-.72-3.09.56.56 0 0 0-.12-.57L11.3 12.7A1 1 0 0 1 11 12V5a1 1 0 1 1 2 0v6.38c0 .13.05.26.15.35l1.3 1.31c.16.15.38.19.58.12a3 3 0 0 1 3.1.72l.52.52c.2.2.5.2.7 0l.53-.52a3 3 0 0 1 2.46-.86c.31.03.63-.17.65-.49L23 12a11 11 0 1 0-10.47 10.99Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M15.3 15.3a1 1 0 0 1 1.4 0l2.3 2.29 2.3-2.3a1 1 0 0 1 1.4 1.42L20.42 19l2.3 2.3a1 1 0 0 1-1.42 1.4L19 20.42l-2.3 2.3a1 1 0 0 1-1.4-1.42L17.58 19l-2.3-2.3a1 1 0 0 1 0-1.4Z"
        className={colorClass}
      />
    </svg>
  );
};
